import { Suspense, ReactNode, lazy, ComponentType } from 'react';
import { ReactPlayerProps } from 'react-player/dist/types';

const ReactPlayer = lazy(
  () => import('react-player'),
) as ComponentType<ReactPlayerProps>;

interface LazyReactPlayerProps extends ReactPlayerProps {
  url?: string;
  width?: string | number;
  height?: string | number;
  fallbackElement?: ReactNode;
}

export const LazyReactPlayer = ({
  url,
  width = '100%',
  height = '100%',
  fallbackElement,
  ...rest
}: LazyReactPlayerProps) => {
  return (
    <Suspense fallback={fallbackElement}>
      <ReactPlayer src={url} width={width} height={height} {...rest} />
    </Suspense>
  );
};
